import React from "react";
import { Button, Modal } from "react-bootstrap";
import { TimesIcon } from "Components/Icons/TimesIcon";

interface CustomModalProps {
    icon?: React.ReactNode;
    title: string;
    children: React.ReactNode;
    show: boolean;
    onClose: () => void;
    className?: string;
}

export const CustomModal = ({ icon, title, children, show, onClose, className }: CustomModalProps) => {
    return (
        <Modal show={show} onClose={onClose} className={`custom-modal ${className}`} centered>
            <Modal.Header>
                <Modal.Title>
                    {icon && <span className="modal-icon me-2">{icon}</span>}
                    {title}
                </Modal.Title>
                <Button variant="link" onClick={onClose}>
                    <TimesIcon className="closeIcon" />
                </Button>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    );
};
